/**
 * Custom sorting functionality for card numbers
 * Adds "Sort by number low to high" and "Sort by number high to low" options
 */
document.addEventListener('DOMContentLoaded', function() {
  // Function to add custom sort options to all sort dropdowns
  function addCustomSortOptions() {
    const sortDropdowns = document.querySelectorAll('select[name="sort_by"]');
    
    sortDropdowns.forEach(dropdown => {
      // Check if custom options already exist to avoid duplicates
      if (!dropdown.querySelector('option[value="card_number-ascending"]')) {
        // Create and add "Sort by number low to high" option
        const lowToHighOption = document.createElement('option');
        lowToHighOption.value = "card_number-ascending";
        lowToHighOption.textContent = "Sort by number low to high";
        dropdown.appendChild(lowToHighOption);
        
        // Create and add "Sort by number high to low" option
        const highToLowOption = document.createElement('option');
        highToLowOption.value = "card_number-descending";
        highToLowOption.textContent = "Sort by number high to low";
        dropdown.appendChild(highToLowOption);
      }
    });
    
    // Check if we need to select one of our custom options based on URL
    const urlParams = new URLSearchParams(window.location.search);
    const sortByParam = urlParams.get('sort_by');
    
    if (sortByParam === 'card_number-ascending' || sortByParam === 'card_number-descending') {
      sortDropdowns.forEach(dropdown => {
        dropdown.value = sortByParam;
      });
      
      // Apply the sorting immediately
      sortProductsByCardNumber(sortByParam);
    }
  }
  
  // Add the custom sort options initially
  addCustomSortOptions();
  
  // Watch for changes in the DOM to add sort options to dynamically loaded dropdowns
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.addedNodes && mutation.addedNodes.length > 0) {
        for (let i = 0; i < mutation.addedNodes.length; i++) {
          const node = mutation.addedNodes[i];
          if (node.nodeType === 1 && (node.tagName === 'SELECT' || node.querySelector)) {
            const dropdowns = node.tagName === 'SELECT' ? [node] : node.querySelectorAll('select[name="sort_by"]');
            if (dropdowns.length > 0) {
              addCustomSortOptions();
            }
          }
        }
      }
    });
  });
  
  // Configure the observer to watch for changes in the entire document
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
  
  // Handle the custom sort options when selected
  document.body.addEventListener('change', function(event) {
    if (event.target.matches('select[name="sort_by"]')) {
      const selectedValue = event.target.value;
      
      // If one of our custom sort options is selected
      if (selectedValue === 'card_number-ascending' || selectedValue === 'card_number-descending') {
        event.preventDefault();
        
        // Get the current URL and parameters
        const url = new URL(window.location.href);
        const params = url.searchParams;
        
        // Update the sort_by parameter
        params.set('sort_by', selectedValue);
        
        // Update the URL without reloading the page
        window.history.pushState({}, '', url.toString());
        
        // Trigger the sorting functionality
        sortProductsByCardNumber(selectedValue);
      }
    }
  });
  
  // Function to sort products by card number
  function sortProductsByCardNumber(sortOrder) {
    const productGrid = document.getElementById('product-grid');
    if (!productGrid) return;
    
    const products = Array.from(productGrid.querySelectorAll('li.grid__item'));
    
    // Sort the products based on the card number metafield
    products.sort((a, b) => {
      // Find the card element within each product item
      const aCard = a.querySelector('.card[data-card-number]');
      const bCard = b.querySelector('.card[data-card-number]');
      
      // Get the card numbers, defaulting to 0 if not found
      const aCardNumber = aCard ? parseInt(aCard.dataset.cardNumber || '0') : 0;
      const bCardNumber = bCard ? parseInt(bCard.dataset.cardNumber || '0') : 0;
      
      // Sort based on the selected order
      if (sortOrder === 'card_number-ascending') {
        return aCardNumber - bCardNumber;
      } else {
        return bCardNumber - aCardNumber;
      }
    });
    
    // Reorder the products in the DOM
    products.forEach(product => {
      productGrid.appendChild(product);
    });
    
    // Also handle table view if it exists
    const tableView = document.getElementById('product-table-container');
    if (tableView && tableView.style.display !== 'none') {
      // If table view is visible, we need to refresh it with the sorted products
      // This would depend on how the table view is implemented
      // For now, we'll just toggle the view to refresh it
      document.getElementById('col_table').click();
      document.getElementById('col_table').click();
    }
  }
});